import { J3WindowBase } from './J3WindowBase';

export class J3ImageWindow extends J3WindowBase{
    windowTop:HTMLElement;
    titleSection:HTMLElement;

    constructor(debugLvl = 0, public name = '', enable = true, visible = true, containerID: string = 'overlay', imageID: string = 'imagepanel',
        titleQuery = '', titleText = '', imageQuery = '', imageFile = '', imageLink = false, linkURL = 'None', target = '_blank') {
        
        super(imageID, debugLvl, true);
        const container = document.querySelector('#' + containerID) as HTMLElement;

        if (enable) {
            /*
            //画像パネルDOM構造
            <section id="imagepanel">
                <div class="popup">
                    <span class="close"><button type="button" id="##"><img src="img/close.png" alt="閉じる"></button></span>
                    <p class="pop_title">Map Title</p>
                    <div class="row box">
                        <div class="col-xxs-12">
                            <a href="https://xooms.co.jp" target="_blank">
                                <img src="" alt="#">
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            */
            //DOM要素を作成
            const section = document.createElement('section');
            section.setAttribute('id', imageID);
            const div = document.createElement('div');
            div.classList.add('popup');
            const span = document.createElement('span');
            span.classList.add('close');
            const button = document.createElement('button');
            button.type = 'button';
            button.setAttribute('id', '##');
            const img = document.createElement('img');
            img.src = 'img/close.png';
            const p = document.createElement('p');
            this.titleSection = p;
            p.classList.add('pop_title');
            p.textContent = titleText;
            const div2 = document.createElement('div');
            div2.classList.add('row');
            div2.classList.add('box');
            const div21 = document.createElement('div');
            div21.classList.add('col-xxs-12');
            const a = document.createElement('a');
            if (imageLink) {
                a.href = linkURL;
                a.target = target;
            }
            const img2 = document.createElement('img');
            img2.src = imageFile;

            //DOM構造を最下位から作成
            if (imageLink) {
                a.appendChild(img2);
                div21.appendChild(a);
            } else {
                div21.appendChild(img2);
            }
            div2.appendChild(div21);
            //
            button.appendChild(img);
            span.appendChild(button);
            div.appendChild(span);
            div.appendChild(p);
            div.appendChild(div2);
            //
            section.appendChild(div);
            this.windowTop = section;
            container.appendChild(section);

            this.SetButtons(imageID);
        } 
    } //constructor end

    SetTitle(text:string){
        this.titleSection.textContent = text;
    }
}